import { PageComponent } from "../types/components";

// Templates para criação de páginas
interface Template {
  id: string;
  name: string;
  description: string;
  components: any[];
}

export const templates: Template[] = [
  {
    id: 'empty',
    name: 'Página Vazia',
    description: 'Comece do zero com uma página em branco',
    components: [],
  },
  {
    id: 'analytics',
    name: 'Dashboard Analytics',
    description: 'Métricas, gráficos e KPIs para análise de dados',
    components: [
      {
        id: `metric-1`,
        type: 'metric-card',
        position: { x: 0, y: 0, w: 12, h: 5 },
        config: {
          title: 'Total de Vendas',
          value: 125430,
          format: 'currency',
          trend: {
            value: 12.5,
            isPositive: true,
          },
          icon: '💰',
        },
      },
      {
        id: `metric-2`,
        type: 'metric-card',
        position: { x: 12, y: 0, w: 12, h: 5 },
        config: {
          title: 'Novos Clientes',
          value: 342,
          format: 'number',
          trend: {
            value: 8.2,
            isPositive: true,
          },
          icon: '👥',
        },
      },
      {
        id: `metric-3`,
        type: 'metric-card',
        position: { x: 24, y: 0, w: 12, h: 5 },
        config: {
          title: 'Taxa de Conversão',
          value: 3.24,
          format: 'percentage',
          trend: {
            value: 2.1,
            isPositive: false,
          },
          icon: '📊',
        },
      },
      {
        id: `metric-4`,
        type: 'metric-card',
        position: { x: 36, y: 0, w: 12, h: 5 },
        config: {
          title: 'Ticket Médio',
          value: 367,
          format: 'currency',
          trend: {
            value: 5.4,
            isPositive: true,
          },
          icon: '💳',
        },
      },
      {
        id: `chart-1`,
        type: 'chart',
        position: { x: 0, y: 6, w: 24, h: 12 },
        config: {
          title: 'Vendas Mensais',
          chartType: 'area',
          dataSource: {
            type: 'static',
            data: [
              { name: 'Jan', value: 4000 },
              { name: 'Fev', value: 3000 },
              { name: 'Mar', value: 5000 },
              { name: 'Abr', value: 4500 },
              { name: 'Mai', value: 6000 },
              { name: 'Jun', value: 5500 },
            ],
          },
          xKey: 'name',
          yKey: 'value',
        },
      },
      {
        id: `chart-2`,
        type: 'chart',
        position: { x: 24, y: 6, w: 24, h: 12 },
        config: {
          title: 'Produtos Mais Vendidos',
          chartType: 'bar',
          dataSource: {
            type: 'static',
            data: [
              { name: 'Produto A', value: 320 },
              { name: 'Produto B', value: 280 },
              { name: 'Produto C', value: 240 },
              { name: 'Produto D', value: 190 },
              { name: 'Produto E', value: 150 },
            ],
          },
          xKey: 'name',
          yKey: 'value',
        },
      },
    ],
  },
  {
    id: 'crud',
    name: 'Gerenciamento de Dados',
    description: 'Tabela com dados e botão para adicionar registros',
    components: [
      {
        id: `table-crud-1`,
        type: 'table',
        position: { x: 0, y: 0, w: 48, h: 15 },
        config: {
          title: 'Registros',
          dataSource: {
            type: 'static',
            data: [
              { id: 1, nome: 'Exemplo 1', status: 'Ativo', data: '01/12/2024' },
              { id: 2, nome: 'Exemplo 2', status: 'Inativo', data: '15/12/2024' },
            ],
          },
          columns: [
            { field: 'id', label: 'ID', type: 'id', visible: false },
            { field: 'nome', label: 'Nome', type: 'text', visible: true },
            { field: 'status', label: 'Status', type: 'badge', visible: true },
            { field: 'data', label: 'Data', type: 'date', visible: true },
          ],
          pagination: true,
          pageSize: 10,
        },
      },
    ],
  },
  {
    id: 'kanban',
    name: 'Kanban Board',
    description: 'Quadro com colunas e cards arrastáveis',
    components: [
      {
        id: `kanban-1`,
        type: 'kanban',
        position: { x: 0, y: 0, w: 48, h: 22 },
        config: {
          title: 'Quadro de Tarefas',
          columns: [
            {
              id: 'todo',
              title: 'A Fazer',
              icon: '📋',
              cards: [
                { 
                  id: '1', 
                  title: 'Implementar nova feature', 
                  description: 'Desenvolver componente de dashboard',
                  badge: 'Alta',
                  color: 'red'
                },
                { 
                  id: '2', 
                  title: 'Revisar código', 
                  description: 'Pull request #123',
                  badge: 'Média',
                  color: 'yellow'
                },
              ],
            },
            {
              id: 'doing',
              title: 'Em Progresso',
              icon: '⚙️',
              cards: [
                { 
                  id: '3', 
                  title: 'Corrigir bug', 
                  description: 'Issue #456',
                  badge: 'Alta',
                  color: 'red'
                },
              ],
            },
            {
              id: 'done',
              title: 'Concluído',
              icon: '✅',
              cards: [
                { 
                  id: '4', 
                  title: 'Atualizar documentação', 
                  description: 'README.md atualizado',
                  badge: 'Baixa',
                  color: 'green'
                },
                { 
                  id: '5', 
                  title: 'Deploy em produção', 
                  description: 'Versão 1.2.0',
                  badge: 'Média',
                  color: 'blue'
                },
              ],
            },
          ],
        },
      },
    ],
  },
];

export function getTemplateById(templateId: string): PageComponent[] {
  const template = templates.find(t => t.id === templateId);
  if (!template) return [];

  const timestamp = Date.now();
  const idMap = new Map<string, string>();
  
  // Primeiro, criar mapeamento de IDs antigos para novos IDs
  template.components.forEach((comp) => {
    const newId = `${comp.id}-${timestamp}-${Math.random().toString(36).substr(2, 9)}`;
    idMap.set(comp.id, newId);
  });
  
  // Depois, criar componentes com IDs atualizados e referências corrigidas
  const componentsWithUniqueIds = template.components.map((comp) => {
    const newId = idMap.get(comp.id)!;
    
    // Se for um botão que referencia outro componente, atualizar a referência
    if (comp.type === 'button' && comp.config.sourceComponentId) {
      const newSourceId = idMap.get(comp.config.sourceComponentId);
      return {
        ...comp,
        id: newId,
        config: {
          ...comp.config,
          sourceComponentId: newSourceId || comp.config.sourceComponentId,
        },
      };
    }
    
    return {
      ...comp,
      id: newId,
    };
  });
  
  return componentsWithUniqueIds as PageComponent[];
}
